interface TemplatesInterface {
  restaurantMenuXlsx: string;
}

const docTemplates: TemplatesInterface = {
  restaurantMenuXlsx: require('./templates/restaurant-menu-template.xlsx'),
};

export default docTemplates;
